import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import InvoiceEditor from "@/pages/sales/InvoiceEditor";
import { toast } from "sonner";

export default function EditInvoice() {
  const { id } = useParams();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/invoices/${id}`); setInv(data); }
      catch(e){ toast.error(formatErr(e)); nav("/invoices"); }
    })();
  }, [id]); // eslint-disable-line

  if (!inv) return <div className="text-center py-12 text-muted-foreground">جاري التحميل...</div>;
  return <InvoiceEditor kind={inv.kind} existing={inv} onSaved={() => nav("/invoices")} />;
}
